import { render, staticRenderFns } from "./truckDetail.vue?vue&type=template&id=9fd84296&scoped=true"
import script from "./truckDetail.vue?vue&type=script&lang=js"
export * from "./truckDetail.vue?vue&type=script&lang=js"
import style0 from "./truckDetail.vue?vue&type=style&index=0&id=9fd84296&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9fd84296",
  null
  
)

export default component.exports